(function () {
  var roots = document.querySelectorAll('.pv-amb');

  roots.forEach(function (root) {
    var viewport = root.querySelector('[data-amb-viewport]');
    var track = root.querySelector('[data-amb-track]');
    var prevBtn = root.querySelector('[data-amb-prev]');
    var nextBtn = root.querySelector('[data-amb-next]');
    var nav = root.querySelector('.pv-amb__nav');
    if (!viewport || !track || !prevBtn || !nextBtn) return;

    // Arrows scroll to an absolute card index (not a relative scrollBy) so fast
    // taps on iOS Safari can't stack onto a half-finished smooth scroll and
    // overshoot into a blank "ghost" slide past either end.
    var targetIndex = -1;
    var settleTimer = null;

    // Start layout aligns cards to the track's left inset instead of centering.
    var alignStart = root.classList.contains('pv-amb--start');

    // Scroll position that centers each card (matches scroll-snap-align: center),
    // or aligns it to the left inset in the start layout, clamped to the
    // viewport's real scroll range.
    function cardOffsets() {
      var cards = track.querySelectorAll('.pv-amb__card');
      var vpRect = viewport.getBoundingClientRect();
      var max = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      var inset = alignStart ? parseFloat(getComputedStyle(track).paddingLeft) || 0 : 0;
      var offsets = [];
      for (var i = 0; i < cards.length; i++) {
        var rect = cards[i].getBoundingClientRect();
        var left = alignStart
          ? rect.left - vpRect.left + viewport.scrollLeft - inset
          : rect.left - vpRect.left + viewport.scrollLeft + rect.width / 2 - viewport.clientWidth / 2;
        offsets.push(Math.round(Math.max(0, Math.min(max, left))));
      }
      return offsets;
    }

    function nearestIndex(offsets) {
      var best = 0;
      for (var i = 1; i < offsets.length; i++) {
        if (Math.abs(offsets[i] - viewport.scrollLeft) < Math.abs(offsets[best] - viewport.scrollLeft)) {
          best = i;
        }
      }
      return best;
    }

    function scheduleSettle() {
      clearTimeout(settleTimer);
      settleTimer = setTimeout(function () {
        targetIndex = -1;
        update();
      }, 150);
    }

    function scrollDir(dir) {
      var offsets = cardOffsets();
      if (!offsets.length) return;
      var current = targetIndex >= 0 ? targetIndex : nearestIndex(offsets);
      var next = current + dir;
      // Cards near the ends clamp to the same scroll position, so skip past
      // them instead of queuing no-op scrolls.
      while (next >= 0 && next < offsets.length && offsets[next] === offsets[current]) {
        next += dir;
      }
      if (next < 0 || next >= offsets.length) return;
      targetIndex = next;
      viewport.scrollTo({ left: offsets[next], behavior: 'smooth' });
      scheduleSettle();
    }

    prevBtn.addEventListener('click', function () {
      if (!prevBtn.classList.contains('is-active')) return;
      scrollDir(-1);
    });
    nextBtn.addEventListener('click', function () {
      if (!nextBtn.classList.contains('is-active')) return;
      scrollDir(1);
    });

    track.addEventListener('click', function (event) {
      var moreBtn = event.target.closest('[data-amb-read-more]');
      var lessBtn = event.target.closest('[data-amb-read-less]');
      if (!moreBtn && !lessBtn) return;
      var wrap = event.target.closest('.pv-amb__quote-wrap');
      if (!wrap) return;
      var truncated = wrap.querySelector('[data-amb-quote="truncated"]');
      var full = wrap.querySelector('[data-amb-quote="full"]');
      if (!truncated || !full) return;
      if (moreBtn) {
        truncated.classList.add('is-hidden');
        full.classList.remove('is-hidden');
      } else {
        full.classList.add('is-hidden');
        truncated.classList.remove('is-hidden');
      }
    });

    function updateNavVisibility() {
      if (!nav) return;
      var needsScroll = viewport.scrollWidth > viewport.clientWidth + 2;
      nav.classList.toggle('is-hidden', !needsScroll);
    }

    function update() {
      var cards = track.querySelectorAll('.pv-amb__card');
      var first = cards[0];
      var last = cards[cards.length - 1];
      if (!first || !last) return;
      var vpRect = viewport.getBoundingClientRect();
      var firstRect = first.getBoundingClientRect();
      var lastRect = last.getBoundingClientRect();
      var atStart = firstRect.left >= vpRect.left - 2;
      var atEnd = lastRect.right <= vpRect.right + 2;
      if (alignStart) {
        // The inset keeps the first card off the edge even after scrolling,
        // so use the scroll range instead of card positions.
        var maxScroll = viewport.scrollWidth - viewport.clientWidth;
        atStart = viewport.scrollLeft <= 2;
        atEnd = viewport.scrollLeft >= maxScroll - 2;
      }
      prevBtn.classList.toggle('is-active', !atStart);
      nextBtn.classList.toggle('is-active', !atEnd);
      updateNavVisibility();
    }

    viewport.addEventListener('scroll', function () {
      requestAnimationFrame(update);
      if (targetIndex >= 0) scheduleSettle();
    });
    window.addEventListener('resize', function () { requestAnimationFrame(update); });

    requestAnimationFrame(update);
    window.addEventListener('load', update);
  });
})();
